import {
  AttributeEditor, Box, FormField, Input, RadioGroup, SpaceBetween,
} from '@cloudscape-design/components';
import { BudgetPeriod, Errors, FmWizardState } from './types';

interface Props {
  state: FmWizardState;
  errors: Errors;
  patch: (p: Partial<FmWizardState>) => void;
}

export default function BudgetStep({ state, errors, patch }: Props) {
  const emailItems = state.businessEmails.map((email, i) => ({ email, index: i }));

  return (
    <SpaceBetween size="m">
      <FormField label="Budget period" description="How the budget amount is applied.">
        <RadioGroup
          value={state.budgetPeriod}
          onChange={({ detail }) => patch({ budgetPeriod: detail.value as BudgetPeriod })}
          items={[
            { label: 'Monthly', value: 'monthly' },
            { label: 'Yearly', value: 'yearly' },
          ]}
        />
      </FormField>

      <FormField label="Amount (USD)" description="Budget threshold in US dollars. Must be greater than 0." errorText={errors.budgetAmount}>
        <Input
          type="number"
          value={state.budgetAmount}
          onChange={({ detail }) => patch({ budgetAmount: detail.value })}
          placeholder="e.g. 500"
        />
      </FormField>

      <FormField label="Business email notifications" description="Optional email addresses to notify on budget alerts.">
        <AttributeEditor
          items={emailItems}
          addButtonText="Add email"
          removeButtonText="Remove"
          onAddButtonClick={() => patch({ businessEmails: [...state.businessEmails, ''] })}
          onRemoveButtonClick={({ detail }) =>
            patch({ businessEmails: state.businessEmails.filter((_, i) => i !== detail.itemIndex) })}
          definition={[
            {
              label: 'Email',
              control: (item) => (
                <FormField description="A business email address to receive notifications." errorText={errors[`businessEmails.${item.index}`]}>
                  <Input
                    value={item.email}
                    placeholder="name@example.com"
                    onChange={({ detail }) =>
                      patch({
                        businessEmails: state.businessEmails.map((e, i) => (i === item.index ? detail.value : e)),
                      })}
                  />
                </FormField>
              ),
            },
          ]}
          empty="No business emails added."
        />
      </FormField>

      <Box color="text-body-secondary">The DevOps team is notified automatically.</Box>
    </SpaceBetween>
  );
}
